export const GET_EVALUATION_TEMPLATE_REQUEST = 'COURSE_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_REQUEST';
export const GET_EVALUATION_TEMPLATE_SUCCESS = 'COURSE_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_SUCCESS';
export const GET_EVALUATION_TEMPLATE_RESULTS_REQUEST =
    'COURSE_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_RESULTS_REQUEST';
export const GET_EVALUATION_TEMPLATE_RESULTS_SUCCESS =
    'COURSE_EVALUATION_TEMPLATE_GET_EVALUATION_TEMPLATE_RESULTS_SUCCESS';
export const DISPOSE = 'COURSE_EVALUATION_TEMPLATE_DISPOSE_STORE';
